import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useLayoutStore } from '../lib/stores/LayoutStore';
import { AuditChecklistPanel } from '../pages/Delivery/Compliance/AuditChecklistPanel';
// Shell for /delivery/* routes. The chrome (sidebar, header, breadcrumbs) and
// the app-wide Assist rail come from DashboardLayout above it; only the audit
// checklist panel (a right-edge surface that survives navigation while an audit
// is worked) mounts here.
export function DeliveryLayout() {
    const setShowHeader = useLayoutStore((s)=>s.setShowHeader);
    // Every delivery page owns an in-content archetype-B header (PageHero /
    // the program sections' display titles), so the layout's generic metadata
    // band is redundant — and on pages the metadata map doesn't know it
    // renders a stale "Dashboard" title above the real header.
    useEffect(()=>{
        setShowHeader(false);
        return ()=>setShowHeader(true);
    }, [
        setShowHeader
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex h-full min-h-0 flex-col",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "min-h-0 flex-1 overflow-auto",
                children: /*#__PURE__*/ _jsx(Outlet, {})
            }),
            /*#__PURE__*/ _jsx(AuditChecklistPanel, {})
        ]
    });
}
